<template>
  <div :data-loading="this.user.loading">
    <v-radio-group mandatory>
      <RadioButton v-for="(option, index) in localOptions" :key="option.alias" :index="index" :item="option" @selected="optionsChange" />
    </v-radio-group>
    <div v-if="user.lists.optiondto.length === 0 && user.lists.timesArrival.length > 0">
      {{ $t('validation.specific.noFreeTimes') }}
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import localizationTexts from '@/localization/texts.json';
import RadioButton from '@/components/fragments/radiobutton.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'AppointmentTypePicker',
  components: {
    RadioButton
  },
  props: {
    options: Array,
    currentSelected: Number
  },
  data() {
    return {
      localOptions: []
    };
  },
  methods: {
    getText(optionId, text) {
      if (optionId !== '1000' && optionId !== '1001' && optionId !== '1002' && optionId !== '1100') {
        return localizationTexts[this.user.config.language].pageDateTime[text];
      } else {
        return text;
      }
    },
    optionsChange(option, index) {
      if (!(typeof index === 'undefined')) {
        this.localOptions[this.currentSelected].checked = false;
      }
      this.$emit('childToParent', option, index);
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  watch: {
    options: {
      handler(newVal) {
        let newOptions = newVal.map((option) => {
          return {
            name: 'appointmenttype',
            alias: option.optionid,
            title: option.optiondisplayname,
            text: option.optiondescription,
            checked: false,
            pickup: option.displaypickuptimes,
            rental: option.isrental
          };
        });

        //Default select first option
        //Visually [0] is chosen because 'mandatory' tag on radio-group
        if (this.currentSelected == 0 && newOptions.length > 0 && !newOptions.some((option) => option.checked)) {
          newOptions[0].checked = true;
          this.optionsChange(newOptions[0]);
        } else if (newOptions.length > 0) {
          newOptions[this.currentSelected].checked = true;
          this.optionsChange(newOptions[this.currentSelected]);
        }
        this.localOptions = newOptions;
      },
      deep: true,
      immediate: true
    }
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
